import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { FaSearch } from 'react-icons/fa'
import ColorCode from '../Components/ColorCode'
import CreateShelfModal from '../Components/CreateShelfModal'
import Input from '../Components/Input'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { GetAllProductShelf } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'

export default function ManageShelf() {
    const { isOpen, onOpen, onClose } = useDisclosure();




    const [PreLoader, setPreLoader] = useState(true);
    const [ModelState, setModelState] = useState("");


    const [Data, setData] = useState([]);
    const [SearchText, setSearchText] = useState("");
    const [CurrentPage, setCurrentPage] = useState(1);
    console.log("currentpage", CurrentPage)
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);

    //get current post

    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentShelf = Data.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    const [Result, setResult] = useState([]);
    const [TotalData, setTotalData] = useState([]);
    const [TransferId, setTransferId] = useState("");



    const handleShelf = () => {

        setModelState("Product Shelf")
        onOpen();

    }

    const GetAllShelf = async () => {
        let result = await GetAllProductShelf()

        console.log("result", result);

        if (result.status === true) {
            setData(result.queryresult.productshelfdetails)
            setTotalData(result.queryresult.totalproductshelfdetails)

            setPreLoader(false)

        }
    }

    console.log("Data shelf", Data)

    const [UpdateShelfPayload, setUpdateShelfPayload] = useState({
        id: "",
        name: "",
        shelfId: "",
        store: "",
        category: ""
    });


    const updateShelf = (id, name, shelfId, store, category) => {

        setUpdateShelfPayload({
            id,
            name,
            shelfId,
            store,
            category
        })


        setModelState("Update Product Shelf")
        onOpen();


    }

    const TransferStore = (id) => {
        setTransferId(id)
        setModelState("Transfer Store")
        onOpen();
    }

    const Migrate = (id) => {
        setTransferId(id)
        setModelState("migrate")
        onOpen();
    }

    const filterData = (e) => {

        setSearchText(e.target.value)

        let result = Data.filter((item) => item.productname.includes(SearchText) || item.productshelfid.includes(SearchText) || item.category?.name.includes(SearchText))

        setResult(result)

    }

    useEffect(() => {
        GetAllShelf()
    }, [isOpen]);
    return (
        <MainLayout>
            {
                PreLoader && (

                    <Preloader />
                )
            }
            <Seo title="Manage Shelf" description='EKO IMS - Manage Shelf' />
            <Flex justifyContent={"space-between"} flexWrap="wrap" fontWeight={"500"} >

                <HStack onClick={handleShelf} cursor={"pointer"} _hover={{ color: "blue.blue600" }}>
                    <Box>
                        <AiOutlinePlus />
                    </Box>
                    <Text>Create Product Shelf</Text>

                </HStack>
                <Text textTransform="capitalize">Total Product Shelves - {TotalData}</Text>

            </Flex>


            <SearchComponent SearchText={SearchText} setSearchText={filterData} Keywords={"productName, ProductShelfId, Category"} />

            <Box height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue300" mt="32px" rounded={"8px"}>

                <ColorCode />

                <TableContainer mt="32px" overflowX="auto" color="#fff">

                    <Table variant='simple' size='sm'>
                        <Thead>
                            <Tr >
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Name</Th>
                                <Th color="#fff">Qty group</Th>
                                <Th color="#fff">Store</Th>
                                <Th color="#fff">Price</Th>
                                <Th color="#fff">Category</Th>
                                <Th color="#fff">Update</Th>
                                <Th color="#fff">Transfer</Th>
                                <Th color="#fff">For Device assignment</Th>
                                <Th color="#fff">Migrate</Th>

                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                SearchText === "" ? (
                                    currentShelf.map((item, i) => (
                                        <TableRow
                                            type="shelf"
                                            key={i}
                                            sn={i + 1}
                                            productName={item.productname}
                                            qty={item.qty?.toLocaleString()}
                                            qtyServiceable={item.qtyserviceable?.toLocaleString()}
                                            qtyUnserviceable={item.qtyunserviceable?.toLocaleString()}
                                            price={item.price?.toLocaleString()}
                                            store={item.store}
                                            isDeviceAssignment={item.fordeviceassignment}
                                            category={item.category?.name}
                                            onClick={() => updateShelf(item._id, item.productname, item.productshelfid, item.store, item.category)}
                                            Transfer={() => TransferStore(item._id)}
                                            migrate={() => Migrate(item._id)}

                                        />
                                    ))
                                ) : (
                                    SearchText !== "" && Data.filter(item => item.productname.toLowerCase().includes(SearchText.toLowerCase()) || item.productshelfid.includes(SearchText) || item.category?.name.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (
                                        Data.filter(item => item.productname.toLowerCase().includes(SearchText.toLowerCase()) || item.productshelfid.includes(SearchText) || item.category?.name.toLowerCase().includes(SearchText.toLowerCase()))
                                            .map((item, i) => (
                                                <TableRow
                                                    type="shelf"
                                                    key={i}
                                                    sn={i + 1}
                                                    productName={item.productname}
                                                    id={item.productshelfid}
                                                    qty={item.qty}
                                                    qtyServiceable={item.qtyserviceable}
                                                    qtyUnserviceable={item.qtyunserviceable}
                                                    price={item.price}
                                                    store={item?.store}
                                                    isDeviceAssignment={item.fordeviceassignment}
                                                    category={item.category?.name}
                                                    onClick={() => updateShelf(item._id, item.productname, item.productshelfid, item.store, item.category)}
                                                    Transfer={() => TransferStore(item._id)}
                                                    migrate={() => Migrate(item._id)}

                                                />
                                            ))
                                    ) : (

                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                                    )
                                )

                            }

                        </Tbody>

                    </Table>
                </TableContainer>

                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />

            </Box>

            <CreateShelfModal onClose={onClose} onOpen={onOpen} isOpen={isOpen} state={ModelState} updatedPayload={UpdateShelfPayload} sendingId={TransferId} />
        </MainLayout>
    )
}
